import script from "./RegistrationData.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationData.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationData.vue?vue&type=style&index=0&id=0cfcfc8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cfcfc8e"]])

export default __exports__